import { Component, Input, OnChanges } from '@angular/core';
import { CollectorEventBucket } from '../availability.model';

@Component({
  selector: 'app-daily-summary',
  templateUrl: './daily-summary.component.html',
  styleUrls: ['./daily-summary.component.css']
})
export class DailySummaryComponent implements OnChanges {
  @Input() date!: string;
  @Input() events: CollectorEventBucket[] = [];

  totalCount = 0;
  breakdownEntries: { key: string; value: number }[] = [];

  ngOnChanges(): void {
    const dayEvents = this.events.filter((e) => e.date === this.date);
    this.totalCount = dayEvents.reduce((acc, e) => acc + e.count, 0);

    const breakdown: Record<string, number> = {};
    for (const event of dayEvents) {
      for (const [key, value] of Object.entries(event.breakdown ?? {})) {
        breakdown[key] = (breakdown[key] ?? 0) + value;
      }
    }
    this.breakdownEntries = Object.entries(breakdown)
      .map(([key, value]) => ({ key, value }))
      .sort((a, b) => b.value - a.value);
  }
}
